import React, {Component} from 'react';
import VIDABOO_CONSTANTS from './config/consts';
// import PostMessageService from "./services/postMessageService"; // must be imported at the beginning.
import Context from './AppModule/Context';

import Main from './AppModule/Main';
import storageService from './services/storageService';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storageLoaded: false,
    };
  }

  async componentDidMount() {
    if (typeof document != 'undefined') {
      document.title = VIDABOO_CONSTANTS.PAGE_TITLE;
    }
    if (storageService.initSyncStorage) {
      await storageService.initSyncStorage(() => {
        this.setState({
          storageLoaded: true,
        });
      });
    } else {
      this.setState({
        storageLoaded: true,
      });
    }
  }
  render() {
    return <Context>{this.state.storageLoaded && <Main />}</Context>;
  }
}

export default App;
